import { JSX, useEffect } from "react";

import { Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Outlet, useNavigate, useParams } from "react-router-dom";
import { useLocationsDataQuery } from "src/api/locationQueries.api";
import TopNav from "src/components/TopNav/TopNav";
import sharedStyles from "src/constants/styles";
import { getLocationsWithTreeDepth, getMinTreeDepth } from "src/lib/locationTree.helper";

function FilesPage(): JSX.Element | null {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const theme = useTheme();
  const { locationId } = useParams();

  const { data: locations } = useLocationsDataQuery();

  useEffect(() => {
    if (locations?.value && !locationId) {
      const minDepth = getMinTreeDepth(locations.value);
      const firstDepthLocations = getLocationsWithTreeDepth(locations?.value, minDepth);
      const firstItem = firstDepthLocations.at(0);
      if (firstItem?.Id) {
        navigate(`/files/${firstItem.Id}`, { replace: true });
      }
    }
  }, [locationId, locations?.value, navigate]);

  return (
    <>
      <TopNav>
        <Typography variant='h3' sx={sharedStyles(theme).topNavTitleText}>
          {t("files")}
        </Typography>
      </TopNav>
      <Outlet />
    </>
  );
}

export default FilesPage;
